import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMaincategory, useEvents, useMain } from "../../actions/homeActions";
export default () => {
  const formatEventDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };
  const [allcategories, setAllcategories] = useState(true);
  const [jobHasMorePages, setEventsHasMorePages] = useState(false);
  const [additionalEvents, setAdditionalEvents] = useState([]);
  const [allEventCurrentPage, setAllEventCurrentPage] = useState(1);
  const [seteledcategories, setSeteledcategories] = useState(false);
  const navigate = useNavigate();
  const [categoriesTtypesEventId, setCategoriesTtypesEventId] = useState(null);
  const {
    data: CategoriesTypesEvents,
    isError,
    error,
  } = useMaincategory("events");
  const {
    data: selectedCategoryEvents,
    isLoading,
    isError: eventsListisError,
    error: eventsListError,
  } = useMain(categoriesTtypesEventId);
  const { data: allEventData, isLoading: eventDataisLoading } =
    useEvents(allEventCurrentPage);
  useEffect(() => {
    if (allEventData) {
      setEventsHasMorePages(allEventData?.has_more_pages);
      setAdditionalEvents((prevEvents) => {
        const newEvent = allEventData?.events || [];
        const uniqueJobs = [...prevEvents, ...newEvent].reduce((acc, event) => {
          if (!acc.some((j) => j.id === event.id)) {
            acc.push(event);
          }
          return acc;
        }, []);
        return uniqueJobs;
      });
    }
  }, [allEventData]);
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading categories Ttypes event: {error.message}
        </p>
      </div>
    );
  }
  if (eventsListisError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading event List: {eventsListError.message}
        </p>
      </div>
    );
  }
  const handleButtonClick = (id) => {
    setAllcategories(false);
    setSeteledcategories(true);
    setCategoriesTtypesEventId(id);
  };

  const handleEvents = (id) => {
    navigate(`/event-details/${id}`);
  };

  return {
    formatEventDate,
    allcategories,
    jobHasMorePages,
    additionalEvents,
    setAllEventCurrentPage,
    seteledcategories,
    CategoriesTypesEvents,
    selectedCategoryEvents,
    isLoading,
    eventDataisLoading,
    handleButtonClick,
    handleEvents,
    setAllcategories,
    setSeteledcategories,
    categoriesTtypesEventId,
    allEventData,
  };
};
